/*
  Productvideo in de galerij.

  Uitgangspunt: niets laden zolang de klant de video niet ziet. De tag staat op
  preload="none", dus pas als het beeld voor de helft in zicht komt halen we de
  bron op en spelen we hem af, zonder geluid en doorlopend. Loopt hij uit beeld,
  dan pauzeren we weer. Op een smal scherm pakken we de lichtere bron: dat
  scheelt ongeveer drie kwart van het dataverkeer.

  Twee keer doen we niets en blijft de posterfoto met de afspeelknop staan:
  als de bezoeker databesparing aan heeft, en als hij in zijn systeem heeft
  staan dat hij minder beweging wil.
*/
(function () {
  var SELECTOR = 'video.maison-product-hero__native-media';

  function zetUit() {
    var verbinding = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (verbinding && verbinding.saveData) return true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    return false;
  }

  function kiesBron(video) {
    var smal = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var stream = video.getAttribute('data-maison-video-smal');
    var kanStream = stream && video.canPlayType && video.canPlayType('application/vnd.apple.mpegurl') !== '';
    var bron = (smal && kanStream) ? stream : video.getAttribute('data-maison-video-breed');
    if (!bron) return;
    if (video.currentSrc === bron) return;
    video.setAttribute('src', bron);
    video.load();
  }

  function start(video) {
    if (video.getAttribute('data-maison-video-gestart')) {
      speel(video);
      return;
    }
    video.setAttribute('data-maison-video-gestart', '1');
    video.muted = true;
    video.setAttribute('muted', '');
    video.loop = true;
    video.playsInline = true;
    kiesBron(video);
    video.preload = 'auto';
    speel(video);
  }

  function speel(video) {
    var poging = video.play();
    if (poging && poging.catch) poging.catch(function () {});
  }

  function init() {
    if (zetUit()) return;
    if (!('IntersectionObserver' in window)) return;
    var videos = document.querySelectorAll(SELECTOR);
    if (!videos.length) return;
    var kijker = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (rij) {
        var video = rij.target;
        if (rij.isIntersecting && rij.intersectionRatio >= 0.5) {
          start(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5] });
    Array.prototype.forEach.call(videos, function (video) {
      if (video.getAttribute('data-maison-video-bekeken')) return;
      video.setAttribute('data-maison-video-bekeken', '1');
      kijker.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
